import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import {
  vaultFile_v0_to_v1,
  vaultFile_v1_to_v2,
  vaultFile_v2_to_v3,
} from "../model-dto/vault-file";
import { VaultFileResponse } from "../../../../models/data/response/vault-file.response";
import { VaultFile } from "../../../../models/data/blobby/vault-file.data";
import { VaultFileStoreModel } from "@bitwarden/web-vault/app/models/store/vault-file.store.model";

export class VaultFileParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported VaultFile parser version ${version}`);
    }

    if (version === 0) {
      return VaultFileParser_v0;
    }

    if (version === 1) {
      return VaultFileParser_v1;
    }

    if (version === 2) {
      return VaultFileParser_v2;
    }

    return VaultFileParser_v3;
  }

  override getSupportedVersion(): number[] {
    return [0, 1, 2, 3];
  }
}

const VaultFileParser_v3 = (vaultItem: any): VaultFileStoreModel =>
  vaultItem as VaultFileStoreModel;

const VaultFileParser_v2 = (vaultItem: any): VaultFileStoreModel => {
  const upgraded = vaultFile_v2_to_v3(vaultItem);
  return VaultFileParser_v3(upgraded);
};

const VaultFileParser_v1 = (vaultItem: any): VaultFileStoreModel => {
  const upgraded = vaultFile_v1_to_v2(vaultItem);
  return VaultFileParser_v2(upgraded);
};

const VaultFileParser_v0 = (vaultItem: any): VaultFileStoreModel => {
  const response = new VaultFileResponse(vaultItem);
  const vaultFile = new VaultFile(response);
  const upgraded = vaultFile_v0_to_v1(vaultFile);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = vaultItem.vid ?? "";
  return VaultFileParser_v1(upgraded);
};
